// Zebra-scanner-inspired palette and common styling constants for the driver demo.

export const COLORS = {
  deviceChassis: '#0a0a0a',
  screenBg: '#0f172a',
  surface: '#1e293b',
  surfaceAlt: '#334155',
  divider: 'rgba(148, 163, 184, 0.2)',
  textPrimary: '#f1f5f9',
  textSecondary: '#94a3b8',
  textMuted: '#64748b',
  accent: '#22d3ee',       // Zebra-like cyan
  accentDim: '#0891b2',
  warn: '#fbbf24',
  danger: '#f43f5e',
  success: '#22c55e',
  hot: '#ef4444',
  cold: '#3b82f6',
  freight: '#f97316',
};

export const DEVICE = {
  width: 380,
  height: 720,
  bezel: 12,
  cornerRadius: 28,
  innerCornerRadius: 14,
};

export const SCREEN_VIEWPORT = {
  width: DEVICE.width - DEVICE.bezel * 2,
  height: DEVICE.height - DEVICE.bezel * 2,
};
